import * as React from 'react';
import { Stack } from '@fluentui/react/lib/Stack';
import Layout from '../layout/Layout';
import { useHistory } from 'react-router-dom';
import { DocumentCardImage, PrimaryButton, Text } from '@fluentui/react';
import { DocumentCard, DocumentCardDetails } from '@fluentui/react';
import styles from './Home.module.scss';
import useUserRoles from '../../hooks/useUserRoles';
import { ChatMode } from '../../enums/ChatMode';
import finance from '../../images/finance.svg'
import intranet from '../../images/ai-governance-untracked.svg'
import Config from '../../constants/Configuration';
const cardsData = [
    {
        title: 'Intranet Chat',
        subtitle: 'WTW Intranet',
        description: 'Welcome to the Intranet Chat. Ask questions to interact with our Intranet sites. Currently only a subset of Intranet content is included to be expanded over time. <a target="_blank" rel="noopener noreferrer" href="https://wtwonline.sharepoint.com/sites/Intranet-Resources/SitePages/Intranet-chat.aspx">Learn more about Intranet Chat<a/>.',
        imageUrl: intranet,
        viewUrl: '/chat',
        shareUrl: Config.IntranetKnowledgebases,
        source: ChatMode.Intranet,
        roles: ["IntranetChatBot.Read.All"]
    },
    {
        title: 'Peer Bot',
        subtitle: 'Finance Peer Review',
        description: 'Ability to chat with agent for the generation of peer comparison insights presented in a tabular format for distribution to executive leadership and the board, utilizing data from SEC filings. You can find more details  <a target="_blank" rel="noopener noreferrer" href="https://wtwonline.sharepoint.com/sites/tctgf_finance_PeerReview/SitePages/Peer-Review-Release-notes.aspx">by visiting our information page<a/>.',
        imageUrl: finance,
        viewUrl: '/chat',
        shareUrl: Config.FinanceKnowledgebases,
        source: ChatMode.FinancePeerReview,
        roles: ["FinancePeerReview.Read.All"]
    }
];

const Home: React.FC = () => {
    console.log("cardsData", cardsData);
    const history = useHistory();
    const roles = useUserRoles();

    const handleCardClick = (viewUrl: string, source: ChatMode, event?: React.MouseEvent) => {

        if (event && isAnchorClick(event)) {
            event?.stopPropagation(); // Prevent card navigation
            return;
        }

        history.push({ pathname: viewUrl, state: source });
    };

    const isAnchorClick = (event: React.MouseEvent): boolean => {
        const target = event.target as HTMLElement;
        return target.tagName.toLowerCase() === 'a';
    };

    // Filter cards based on user roles
    const filteredCards = cardsData.filter(card => card.roles.some(role => roles.includes(role)));

    return (
        <Layout>
            <Stack enableScopedSelectors className={styles.root} tokens={{ childrenGap: 10 }}>
                <Stack verticalFill >
                    <Stack.Item>
                        <Text variant="xLargePlus" styles={{ root: { marginLeft: '5px', color: '#7f35b2' } }}>Knowledgebases</Text>
                    </Stack.Item>
                    <Stack.Item>
                        <Text variant="mediumPlus" styles={{ root: { marginLeft: '5px' } }}>Select a knowledge base below.</Text>
                    </Stack.Item>
                </Stack>
                <Stack horizontal >
                    {/* // user filter card after security group implementation  */}
                    {filteredCards.map((card, index) => {

                        return (
                            <Stack key={card.title} onClick={(e) => handleCardClick(card.viewUrl, card.source, e)} className={styles.cardContainer}>
                                <DocumentCard className={styles.modernCard}>
                                    <Stack tokens={{ childrenGap: 10 }} >
                                        <Stack tokens={{ childrenGap: 10 }} horizontal>
                                            <Stack>
                                                <Stack.Item className={styles.cardIcon}>
                                                    <DocumentCardImage imageSrc={card.imageUrl} />
                                                </Stack.Item>
                                            </Stack>
                                            <Stack styles={{ root: { width: '60%' } }} verticalAlign='center'>
                                                <Stack.Item>
                                                    <Text variant="mediumPlus" className={styles.cardHeader}>{card.title}</Text>
                                                </Stack.Item>
                                                <Stack.Item>
                                                    <Text variant="medium" className={styles.cardSubHeader}>{card.subtitle}</Text>
                                                </Stack.Item>
                                            </Stack>
                                        </Stack>
                                        <Stack horizontal className={styles.cardDescription} verticalAlign="start">

                                            <Stack.Item >
                                                <DocumentCardDetails>
                                                    <Stack.Item>
                                                        <Text variant='small' className={styles.cardDescriptionItem}><span dangerouslySetInnerHTML={{ __html: card.description }}></span></Text>
                                                    </Stack.Item>
                                                </DocumentCardDetails>
                                            </Stack.Item>
                                        </Stack>
                                        <Stack horizontal tokens={{ childrenGap: 10 }} styles={{ root: { padding: '10px', justifyContent: 'center' } }}>
                                            <PrimaryButton className={styles.btnPrimary} text="View" onClick={() => handleCardClick(card.viewUrl, card.source)} />
                                            {/* <PrimaryButton className={styles.btnPrimary} text="Share" onClick={() => window.open(card.shareUrl, '_blank')} /> */}
                                        </Stack>
                                    </Stack>
                                </DocumentCard>
                            </Stack>
                        );
                    })}
                </Stack>
            </Stack>
        </Layout>
    );
};

export default Home;